import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';
import { servicesProviderSaleDataSchema } from './ServicesProviderSaleData.js';

class ServicesProviderSale extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
        this.physicalAddress = data.physicalAddress;
        this.dealerLicenseDocument = data.dealerLicenseDocument;
        this.authorizedRepresentativeIdentityDocument =
            data.authorizedRepresentativeIdentityDocument;
        this.agents = data.agents;
        this.support = data.support;
    }
    validateData(data) {
        const result = servicesProviderSaleDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderSale.validation', `ServicesProviderSale data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.SALE,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
    // can change this to get a specific agent based on the service that agent functions for
    // OR based on state or other criteria
    /**
     * Gets an agent from this ServicesProvider.
     * @param index - The index of the agent to retrieve (default: 0)
     * @returns The agent at the specified index, or null if not found
     */
    getAgent(index = 0) {
        return this.agents?.[index] ?? null;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.SALE, ServicesProviderSale);

export { ServicesProviderSale };
//# sourceMappingURL=ServicesProviderSale.js.map
